<template>
  <div class="home h-100">
    <NavbarMain />
    <div class="row h-100 m-0">
      <div class="col-xl-auto h-100 p-0 col-sm-12 h-sm-auto">
        <NavbarAdmin />
      </div>
      <div class="col">
        <h1 class="text-center py-4">Productos</h1>
        <FilterMenu :filterSate="true" :filterMenu="true" typePublication="product" :filterName="true" :filterAmountElements="true" />
        <div class="container">
          <table class="table">
            <thead class="thead-dark text-center">
              <tr>
                <th scope="col" class="d-md-table-cell d-sm-none"></th>
                <th scope="col">Producto</th>
                <th style="min-width: 7em" scope="col">Precio SC$</th>
                <th style="min-width: 10em" scope="col">Precio vendedor</th>
                <th scope="col">Vendedor</th>
                <th scope="col">Fecha</th>
                <th scope="col">Estado</th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody class="text-center" v-if="productFiltered.length">
              <tr v-for="product in productFiltered" :key="product._id">
                <td class="d-md-block d-sm-none">
                  <img
                    class="img-fluid img-thumbnail"
                    v-bind:src="url+'public/images/products/'+product.images[0]"
                    alt="Card image cap"
                    style="height:60px !important"
                  />
                </td>
                <td class="align-middle">
                  <span>{{product.name}}</span>
                </td>
                <td class="align-middle">SC$ {{ localToSC(product.price, product.currency) }}</td>
                <td
                  class="align-middle"
                >{{ product.currency }}$ {{ product.price.toFixed(2) }}</td>
                <td class="align-middle">{{product.sellerId ? product.sellerId.username : ''}}</td>
                <td
                  class="align-middle"
                >{{product.creationDate.replace(/T/, ' ').replace(/\..+/, '')}}</td>
                <td class="align-middle" v-if="product.state == 0">
                  <span class="badge badge-warning mr-1">En espera</span>
                </td>
                <td class="align-middle" v-if="product.state == 1">
                  <span class="badge badge-success mr-1">Activo</span>
                </td>
                <td class="align-middle" v-if="product.state == 2">
                  <span class="badge badge-danger mr-1">Cancelado</span>
                </td>
                <td class="align-middle" v-if="product.state == 3">
                  <span class="badge badge-secondary mr-1">Eliminado</span>
                </td>
                <td class="align-middle" v-if="product.state == 4">
                  <span class="badge badge-primary mr-1">Pausado</span>
                </td>
                <td class="align-middle">
                  <router-link
                    :to="{ name: 'AdminProduct', params: { id: product._id, title: product.name.replace(/\s/g,'-') }}"
                  >
                    <span class="material-icons text-info" title="Editar publicacion">settings</span>
                  </router-link>
                  <router-link v-if="product.state != 3 && product.state != 2"
                    :to="{ name: 'AdminCancelProduct', params: { id: product._id, title: product.name.replace(/\s/g,'-') }}"
                  >
                    <span
                      class="material-icons text-danger"
                      title="Cancelar publicacion"
                    >delete_outline</span>
                  </router-link>
                </td>
              </tr>
            </tbody>
            <tbody  v-else>
              <tr>
                <td colspan="8" class="text-center">
                  No hay ningun producto que cumpla con el filtro
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavbarMain from "@/components/NavbarMain.vue";
import NavbarAdmin from "@/components/NavbarAdmin.vue";
import FilterMenu from "@/components/admin/FilterMenu.vue";
import Configs from "@/configs/configs";
import Api from "../../tools/Api2"
import { mapState } from "vuex";
import { LC } from "@/tools/exchange";

export default {
  name: "AdminProducts",
  data() {
    return {
      products: [],
      localCurrency: null,
      url: Configs.API.BASE,
      filterMenuParms: {
        filterName: "",
        filterAmountElements: 50,
        filterState: 0,
        orderBy: {
          sort: "creationDate",
          asc: false,
        },
      },
    };
  },
  computed: {
    ...mapState(["auth", "changes"]),
    productFiltered() {
      return this.products
        .filter((e) => (this.filterMenuParms.filterState == e.state) && (e.name.toUpperCase().includes(this.filterMenuParms.filterName.toUpperCase()) || e.sellerId.username.toUpperCase().includes(this.filterMenuParms.filterName.toUpperCase())))
        .sort((a, b) => {
          if (
            this.filterMenuParms.orderBy.asc
              ? a[this.filterMenuParms.orderBy.sort] >
                b[this.filterMenuParms.orderBy.sort]
              : a[this.filterMenuParms.orderBy.sort] <
                b[this.filterMenuParms.orderBy.sort]
          ) {
            return 1;
          }
          if (
            this.filterMenuParms.orderBy.asc
              ? a[this.filterMenuParms.orderBy.sort] <
                b[this.filterMenuParms.orderBy.sort]
              : a[this.filterMenuParms.orderBy.sort] >
                b[this.filterMenuParms.orderBy.sort]
          ) {
            return -1;
          }
          return 0;
        }).slice(0, this.filterMenuParms.filterAmountElements);
    },
  },
  methods: {
    localToSC(price, currency) {
      if (!this.localCurrency) return "-";
      return this.localCurrency.localToSC({ price, currency }).toFixed(2);
    },
  },
  components: {
    NavbarMain,
    NavbarAdmin,
    FilterMenu,
  },
  created: function () {
    LC.new().then((localCurrency) => {
      this.localCurrency = localCurrency;
    });
    Api("product").get().then( res => {
      this.products = res.products.filter(e => e.sellerId).map( e=> { return {...e, seller: e.sellerId.username} });
    })
  },
};
</script>
